//Angular
import { inject } from "@angular/core";
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from "@angular/common/http";

// RXJS
import { catchError, Observable, of, switchMap, throwError } from "rxjs";

//Services
import { TranslationService } from "#services/translation/translation.service";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "#services/auth/auth.service";

export const httpRequestInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const publicRoutes: string[] = [];
    const translationService = inject(TranslationService);
    const cookieService = inject(CookieService);
    const authService = inject(AuthService);

    const modifiedReq = req.clone({
        withCredentials: !publicRoutes.find((publicRoute) => req.url.includes(publicRoute)),
        setHeaders: {
            Language: translationService.currentLanguage,
            "X-XSRF-token": cookieService.get("XSRF-TOKEN"),
        },
    });

    return next(modifiedReq).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                switch (error.status) {
                    case 401:
                        console.warn("Unauthorized (401) detected, logging out...");
                        if (
                            ![
                                authService.logoutUrl,
                                authService.checkAuthUrl,
                                authService.loginUrl,
                            ].find((route) => req.url.includes(route))
                        ) {
                            authService.logout();
                        }
                        break;

                    case 419:
                        console.warn("CSRF TOKEN MISMATCH (419) detected, retry...");
                        if (!req.url.includes(authService.tokenUrl)) {
                            return of(error).pipe(
                                switchMap(() => authService.getToken()),
                                switchMap(() => next(modifiedReq)),
                                catchError((err) => {
                                    console.error("Max retries reached, logging out...");
                                    if (authService.isAuthenticatedSubject.getValue()) {
                                        authService.logout();
                                    }

                                    return throwError(() => err);
                                })
                            );
                        }
                        break;

                    default:
                        break;
                }
            }

            return throwError(() => error);
        })
    );
};
